import { QuestionBase } from '../question-types/question-base';

export class EmptyQuestion extends QuestionBase<boolean> {
  controlType = 'empty';

  constructor(options: {} = {}) {
    super(options);
  }
}
